var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.travel)?_c('div',[_vm._l((_vm.travel.timeline),function(item){return [_c('timeline-element',{key:item.id,attrs:{"day-details":item}})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }